<template>
    <div class="b-table-sticky-header table-responsive mt-1" style="max-height:364px;">
        <b-table-simple
            no-border-collapse
            striped
            small
            class="mb-0"
        >
            <b-thead>
                <b-th
                    v-for="(header, headerIdx) in headers"
                    :key="headerIdx"
                    :style="header.style"
                    :class="header.class"
                >
                    {{ header.title }}
                </b-th>
            </b-thead>
            <b-tbody>
                <b-tr v-for="(regionKey, nodeIdx) in twoMonthRegions" :key="nodeIdx">
                    <b-td>
                        {{__getRegionFullNameByKey(regionKey)}}
                    </b-td>
                    <b-td>
                        {{  __getRegionTypeByKey(regionKey) }}
                    </b-td>
                    <b-td class="text-right">
                        {{ getPrevMonthCostByRegionKey(regionKey) != '-' ? $_getDollar(getPrevMonthCostByRegionKey(regionKey)) : '-'}}
                    </b-td>
                    <b-td class="text-right font-weight-bold">
                        <a @click="emitDetailLayer(regionKey)" v-if="getThisMonthCostByRegionKey(regionKey) != '-'">{{ $_getDollar(getThisMonthCostByRegionKey(regionKey))}}</a>
                        <span v-if="getThisMonthCostByRegionKey(regionKey) == '-'">-</span>
                    </b-td>
                    <b-td class="text-right" v-html="getTrendByRegionKey(regionKey)"></b-td>
                </b-tr>
            </b-tbody>
        </b-table-simple>
    </div>
</template>

<script>
import useCommonData from '@/composables/useCommonData'
import { computed, toRefs, getCurrentInstance } from '@vue/composition-api'
export default {
    props: {
        thisMonthRegions: {
            type: Array,
            default: function () {
                return []
            }
        },
        lastMonthRegions: {
            type: Array,
            default: function () {
                return []
            }
        }
    },
    setup (props, context) {
        const vm = getCurrentInstance().proxy
        const { thisMonthRegions, lastMonthRegions } = toRefs(props)
        const headers = [
            {
                title: vm.$t('v4.Region'),
                style: {
                    position: 'sticky',
                    top: '-1px',
                    'z-index': 2
                }
            },
            {
                title: vm.$t('v4.Type'),
                style: {
                    position: 'sticky',
                    top: '-1px',
                    'z-index': 2
                }
            },
            {
                title: vm.$t('v4.Prev'),
                style: {
                    width: '20%',
                    position: 'sticky',
                    top: '-1px',
                    'z-index': 2
                },
                class: {
                    'text-right': true
                }
            },
            {
                title: vm.$t('v4.This Month'),
                style: {
                    width: '20%',
                    position: 'sticky',
                    top: '-1px',
                    'z-index': 2
                },
                class: {
                    'text-right': true
                }
            },
            {
                title: '',
                style: {
                    width: '20%',
                    position: 'sticky',
                    top: '-1px',
                    'z-index': 2
                },
                class: {
                    'text-right': true
                }
            }
        ]
        const { __getRegionFullNameByKey, __getRegionTypeByKey } = useCommonData()
        const twoMonthRegions = computed(() => {
            return thisMonthRegions.value.map(item => item.key)
                .concat(lastMonthRegions.value.map(item => item.key))
                .filter((obj, pos, arr) => {
                    return arr.indexOf(obj) === pos
                })
        })
        const getPrevMonthCostByRegionKey = (key) => lastMonthRegions.value.find(region => region.key === key) ? lastMonthRegions.value.find(region => region.key === key).cost : '-'
        const getThisMonthCostByRegionKey = (key) => thisMonthRegions.value.find(region => region.key === key) ? thisMonthRegions.value.find(region => region.key === key).cost : '-'
        const getTrendByRegionKey = (key) => {
            let thisMonthCost = getThisMonthCostByRegionKey(key) !== '-' ? getThisMonthCostByRegionKey(key) : 0
            let prevMonthCost = getPrevMonthCostByRegionKey(key) !== '-' ? getPrevMonthCostByRegionKey(key) : 0

            let diffCost = thisMonthCost - prevMonthCost

            let output = (diffCost < 0 ? '-' : '+') + vm.$_getDollar(Math.abs(diffCost))

            if (getPrevMonthCostByRegionKey(key) !== '-' && getPrevMonthCostByRegionKey(key) !== 0) {
                output += ' <small>(' + Math.round(diffCost / getPrevMonthCostByRegionKey(key) * 1000) / 10 + '%)</small>'
            }

            return output
        }
        const emitDetailLayer = (region) => context.emit('detail-layer', region)
        return {
            headers,
            twoMonthRegions,
            __getRegionTypeByKey,
            __getRegionFullNameByKey,
            getPrevMonthCostByRegionKey,
            getThisMonthCostByRegionKey,
            getTrendByRegionKey,
            emitDetailLayer
        }
    }
}
</script>

<style>

</style>
